export default __webpack_public_path__ + "4e851037f22f76ecbdacc311f640fe60.png";